import React from 'react';
import classnames from 'classnames';

import { ProductsListingWidget } from 'components/product';
import { useBlogStore } from 'context/BlogContext';
import { getLandingPageAnalyticsProps } from 'helpers/LandingPageHelpers';

import styles from './AlphaTemplateProductsBlock.module.scss';

interface Props {
  className?: string,
  listingSlug: string,
  listingType?: 'promotion' | 'customListing',
  title?: string,
  isTitleHidden?: boolean,
  isMobilePreview?: boolean
}

const AlphaTemplateProductsBlock = (props: Props) => {

  const {
    className,
    listingSlug,
    listingType,
    title,
    isTitleHidden,
    isMobilePreview,
  } = props;

  // Hooks

  const { blogPageProps } = useBlogStore();

  // Props

  const {
    slug: landingPageSlug,
    title: landingPageTitle
  } = blogPageProps || {};

  // Render

  return (
    <div className={classnames(styles.root, className)}>
      <div className={styles.inner}>
        <ProductsListingWidget
          isTitleHidden={isTitleHidden}
          listingSlug={listingSlug}
          listingType={listingType as any}
          title={title}
          isMobilePreview={isMobilePreview}
          getAnalyticsProps={(_, listingTitle) => {
            return getLandingPageAnalyticsProps(
              landingPageSlug,
              landingPageTitle,
              listingSlug,
              listingTitle
            );
          }}
        />
      </div>
    </div>
  );
};

export default AlphaTemplateProductsBlock;
